import { render } from "./ListeEquipagePage.vue?vue&type=template&id=0b38bb2a&ts=true"
import script from "./ListeEquipagePage.vue?vue&type=script&lang=ts"
export * from "./ListeEquipagePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__